import { createContext,useEffect,useReducer } from "react";

export const AuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {
        case 'ADMIN_LOGIN':
        return {adminuser: action.payload}

        case 'ADMIN_LOGOUT':
            return {adminuser:null}

        default:
            return state;    
    }
}

export const AuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        adminuser:null
    });

    useEffect(()=>{
        const adminuser = JSON.parse(localStorage.getItem('adminuser'));
        if(adminuser){
            dispatch({type:'ADMIN_LOGIN', payload:adminuser});
        }

    },[]);

    console.log('AuthContext State ', state);

    return (
        <AuthContext.Provider value={{...state,dispatch}}>
            {children}
        </AuthContext.Provider>
    )
}
